import React from "react";
import Box from "@mui/material/Box";

const ControlContainer = ({ children, title, icon }) => {
  const handleIconDisplay = () => {
    if (!icon) {
      return <></>;
    }
    return <Box className="icon-container">{icon}</Box>;
  };

  const handleTitleDisplay = () => {
    if (!title) {
      return <></>;
    }
    return (
      <p
        style={{
          fontWeight: "700",
          marginBottom: "10px",
        }}
      >
        {title}
      </p>
    );
  };

  return (
    <Box
      sx={{
        minHeight: "270px",
        backgroundColor: "#f1f1f1",
        borderRadius: "15px",
        width: "300px",
        padding: "20px",
        position: "relative",
        display: "inline-block",
      }}
    >
      {handleIconDisplay()}
      {handleTitleDisplay()}
      {children}

      {/* <Button
      sx={{
        padding: "0",
        minWidth: "auto",
        position: "absolute",
        top: "20px",
        right: "20px",
        textTransform: "none",
        fontSize: "10px",
        fontWeight: "600",
        color: "var(--gray-text)",
      }}
      onClick={() => handleEditProfile()}
    >
      Edit
    </Button> */}
    </Box>
  );
};

export default ControlContainer;
